import React from "react";
import Typography from "@material-ui/core/Typography";

const InvestigatorTitleBadge = ({ title }) => {
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        alignItems: "center",
        background: "#1E2CBC",
        paddingLeft: "16px",
        paddingRight: "26px",
        paddingTop: "7px",
        paddingBottom: "7px",
        height: "fit-content",
        clipPath:
          "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)",
      }}
    >
      <Typography
        style={{
          color: "#FFFFFF",
          fontSize: 14,
          fontFamily: "Source Sans Pro, sans-serif",
          fontWeight: "600",
          textTransform: "capitalize",
          lineHeight: 1.2,
          wordWrap: "break-word",
          height: "100%",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>

      {/* Right triangle */}
      <div
        style={{
          width: 0,
          height: 0,
          borderTop: "15px solid transparent",
          borderBottom: "15px solid transparent",
          borderLeft: "10px solid #1E2CBC",
          position: "absolute",
          right: "-10px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      />
    </div>
  );
};

export default InvestigatorTitleBadge;
